import { z } from 'zod';
import { normalizeString } from 'utils/Validations';

export const accrualRuleSchema = (t: any, rows: any[], currentId?: number) => {
    return z.object({
        name: z.string()
                .transform(val => val.trim())
                .pipe(
                    z.string()
                        .min(2, { message: t('general.zod.string.min_chars', { min: 2 }) })
                        .max(100, { message: t('general.zod.string.max_chars', { max: 100 }) })
                        .refine(
                            (val) => /^[a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑüÜ\-_]+$/.test(val),
                            { message: t('general.zod.string.invalid_characters') }
                        )
                        .refine(
                            (val) => {
                                const normalizedName = normalizeString(val);
                                if (currentId !== undefined) {
                                    const selected = rows.find((row: any) => row.id === currentId);
                                    if (selected && normalizeString(selected.name) === normalizedName) {
                                        return true;
                                    }
                                }
                                return !rows.some((row: any) => normalizeString(row.name) === normalizedName);
                            },
                            { message: t('accruals.accrual_rules.dialog.alerts.name_exist') }
                        )
                ),
        description: z.string().nullable(),
        adjustBalance: z.boolean(),
        accrualCodeId: z.union([z.number(), z.literal("")]).refine((val) => typeof val === 'number' && val > 0, {
            message: t('accruals.accrual_rules.dialog.alerts.select_accrual_code')
        }),
        accrualSurplusId: z.union([z.number(), z.null()]).nullable(),
        referenceDateServiceId: z.union([z.number(), z.null()]).nullable(),
    });
};